(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3361],{

/***/ 30377:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Logo_Logo; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/Logo/Logo.module.scss
var Logo_module = __webpack_require__(27259);
var Logo_module_default = /*#__PURE__*/__webpack_require__.n(Logo_module);
;// CONCATENATED MODULE: ./components/Logo/assets/medrecruit-full.svg
var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

var SvgMedrecruitFull = function SvgMedrecruitFull(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    width: 182,
    height: 42,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
    d: "m26.367 14.226 3.573-9.028A3.861 3.861 0 0 0 27.795.215l-.176-.061a3.44 3.44 0 0 0-.525-.149H26.761a4.02 4.02 0 0 0-.403 0h-.692a4.383 4.383 0 0 0-.525.149l-.184.061a3.862 3.862 0 0 0-2.128 4.983l3.538 9.028ZM11.83 14.226l3.565-9.028A3.844 3.844 0 0 0 13.258.215l-.175-.061a3.44 3.44 0 0 0-.526-.149h-.289a4.02 4.02 0 0 0-.402 0H11.173a4.383 4.383 0 0 0-.525.149l-.184.061a3.853 3.853 0 0 0-2.127 4.983l3.494 9.028ZM26.367 24.28l-3.573 9.028a3.853 3.853 0 0 0 2.146 4.982l.166.062c.174.064.352.114.534.149h1.384c.178-.04.353-.09.525-.15l.184-.06a3.862 3.862 0 0 0 2.137-4.983l-3.503-9.029ZM11.83 24.28l-3.572 9.028a3.844 3.844 0 0 0 2.145 4.982l.167.062c.173.064.352.114.534.149h1.384c.177-.04.353-.09.525-.15l.184-.06a3.853 3.853 0 0 0 2.128-4.983l-3.494-9.029Z",
    fill: "#278BE0"
  })), _path2 || (_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M34.82 23.4a3.94 3.94 0 1 0-1.262-7.78 3.94 3.94 0 0 0 1.263 7.78ZM19.064 23.456a3.94 3.94 0 1 0 0-7.881 3.94 3.94 0 0 0 0 7.881ZM3.94 15.575a3.94 3.94 0 1 0 3.941 3.94 3.95 3.95 0 0 0-3.94-3.94ZM45.308 11.503h2.969l.385 2.19a5.121 5.121 0 0 1 4.475-2.55 4.448 4.448 0 0 1 4.273 2.55 5.421 5.421 0 0 1 4.65-2.55c3.18 0 5.342 2.05 5.342 5.964v9.221H63.9v-8.835c0-2.198-1.007-3.232-2.522-3.232-1.812 0-3.319 1.603-3.319 4.922v7.145h-3.502v-8.835c0-2.198-1.007-3.232-2.522-3.232-1.752 0-3.32 1.603-3.32 5.07v7.006h-3.502l.096-14.834ZM76.264 26.688c-4.562 0-7.443-3.267-7.443-7.742 0-4.474 2.995-7.802 7.417-7.802 4.799 0 7.294 3.415 7.294 7.356.009.45-.032.899-.122 1.34H72.236a3.95 3.95 0 0 0 4.23 3.791 3.88 3.88 0 0 0 3.678-2.224l2.872 1.34c-1.086 2.338-3.372 3.94-6.752 3.94ZM72.29 17.37h7.74a3.6 3.6 0 0 0-3.791-3.345 3.8 3.8 0 0 0-3.95 3.345ZM91.738 26.687c-4.002 0-7.146-3.17-7.146-7.767 0-4.781 3.354-7.776 7.268-7.776a5.552 5.552 0 0 1 4.624 2.207V5.128h3.503v21.2h-2.969l-.385-2.014a5.877 5.877 0 0 1-4.895 2.373Zm-3.643-7.767c0 2.723 1.839 4.685 4.326 4.685 2.487 0 4.273-1.9 4.273-4.685 0-2.785-1.839-4.694-4.273-4.694-2.435 0-4.326 1.962-4.326 4.694ZM102.281 11.503h2.942l.324 2.031a4.205 4.205 0 0 1 3.915-2.39 5.063 5.063 0 0 1 2.233.508l-.736 3.503a4.255 4.255 0 0 0-2.145-.56c-1.883 0-3.092 1.383-3.092 3.94v7.688h-3.441v-14.72ZM118.499 26.574c-4.536 0-7.391-3.24-7.391-7.68 0-4.44 2.969-7.75 7.356-7.75 4.772 0 7.242 3.389 7.242 7.303.007.444-.031.887-.114 1.323h-11.113c.359 2.627 2.032 3.774 4.212 3.774a3.855 3.855 0 0 0 3.652-2.207l2.855 1.322c-1.086 2.32-3.354 3.915-6.699 3.915Zm-3.95-9.248h7.689a3.592 3.592 0 0 0-3.739-3.319 3.757 3.757 0 0 0-3.958 3.32h.008ZM126.678 18.859a7.414 7.414 0 0 1 7.583-7.715 6.796 6.796 0 0 1 6.594 4.15l-3.091 1.297a3.682 3.682 0 0 0-3.591-2.382c-2.355 0-3.975 1.918-3.975 4.65s1.646 4.65 4.063 4.65a3.678 3.678 0 0 0 3.503-2.356l3.117 1.331a7.007 7.007 0 0 1-6.716 4.09 7.367 7.367 0 0 1-5.413-2.238 7.373 7.373 0 0 1-2.074-5.477ZM142.011 11.503h2.942l.324 2.032a4.23 4.23 0 0 1 3.923-2.391 5.057 5.057 0 0 1 2.233.508l-.735 3.503a4.256 4.256 0 0 0-2.146-.56c-1.891 0-3.091 1.383-3.091 3.94v7.688h-3.45v-14.72ZM152.388 20.417v-8.914h3.441v8.415c0 2.356 1.209 3.564 3.065 3.564 1.857 0 3.503-1.593 3.503-4.886v-7.093h3.442v14.72h-2.943l-.385-2.18a5.305 5.305 0 0 1-4.606 2.53c-3.503 0-5.517-2.241-5.517-6.156ZM167.686 11.503h3.442v14.72h-3.442v-14.72ZM174.587 14.331h-2.084v-2.828h2.084V7.615l3.45-.762v4.65h3.231v2.828h-3.222v11.892h-3.45l-.009-11.892ZM169.403 10.067a2.11 2.11 0 1 0 0-4.221 2.11 2.11 0 0 0 0 4.22Z",
    fill: "#55ADEE"
  })), _path3 || (_path3 = /*#__PURE__*/react.createElement("path", {
    d: "M45.308 35.62a2.74 2.74 0 0 1 2.706-2.9 2.277 2.277 0 0 1 1.857.877l.122-.78h.876v5.526h-.876l-.122-.78a2.215 2.215 0 0 1-1.857.876 2.741 2.741 0 0 1-2.706-2.82Zm4.677 0a1.833 1.833 0 0 0-1.813-1.988 1.997 1.997 0 0 0 0 3.975 1.84 1.84 0 0 0 1.813-1.987ZM54.766 32.852h.876l.122.876a1.9 1.9 0 0 1 1.673-1.016 1.62 1.62 0 0 1 1.646 1.025 2.015 2.015 0 0 1 1.751-1.025c1.296 0 2.023.832 2.023 2.303v3.354h-.998v-3.328c0-.971-.464-1.41-1.077-1.41-.806 0-1.462.763-1.462 2.225v2.522h-.981V35.04c0-.971-.464-1.41-1.095-1.41-.788 0-1.445.727-1.445 2.295v2.452h-.998l-.035-5.526ZM66.517 38.51a2.628 2.628 0 0 1-2.723-2.882 2.715 2.715 0 0 1 2.715-2.907 2.567 2.567 0 0 1 2.627 2.776c.009.131.009.263 0 .394h-4.379a1.75 1.75 0 0 0 1.84 1.751 1.646 1.646 0 0 0 1.558-.972l.823.35a2.54 2.54 0 0 1-2.46 1.49Zm-1.75-3.38h3.353a1.533 1.533 0 0 0-1.629-1.498 1.647 1.647 0 0 0-1.707 1.497h-.018ZM72.507 38.51a2.898 2.898 0 0 1 0-5.79 2.198 2.198 0 0 1 1.822.93v-3.17h.998v7.88h-.876l-.105-.779a2.25 2.25 0 0 1-1.839.928Zm-1.751-2.89a1.875 1.875 0 0 0 1.839 1.987 1.996 1.996 0 0 0 0-3.975 1.873 1.873 0 0 0-1.804 1.987h-.035ZM76.028 32.852h1.015l1.331 4.431 1.148-3.082-.43-1.349h.972l1.428 4.431 1.322-4.43h1.016l-1.795 5.525h-1.042l-1.025-3.047-1.077 3.047h-1.016l-1.847-5.526ZM83.97 35.62a2.854 2.854 0 1 1 2.855 2.89 2.81 2.81 0 0 1-2.855-2.89Zm4.685 0a1.839 1.839 0 1 0-1.83 1.987 1.847 1.847 0 0 0 1.83-1.987ZM90.713 32.852h.876l.105.788a1.568 1.568 0 0 1 1.436-.875c.305-.004.606.068.876.21l-.237 1.007a1.752 1.752 0 0 0-.797-.201c-.805 0-1.252.621-1.252 1.655v2.986h-.998l-.009-5.57ZM94.671 30.48h.99v7.88h-.99v-7.88ZM99.435 38.51a2.898 2.898 0 0 1 0-5.79 2.197 2.197 0 0 1 1.821.93v-3.17h.999v7.88h-.876l-.114-.779a2.217 2.217 0 0 1-1.83.928Zm-1.752-2.89a1.867 1.867 0 0 0 1.84 1.987 1.998 1.998 0 0 0 1.289-3.332 1.998 1.998 0 0 0-1.29-.643 1.865 1.865 0 0 0-1.803 1.987h-.036ZM106.151 32.852h.876l.123.762a2.423 2.423 0 0 1 1.9-.876 2.704 2.704 0 0 1 2.627 2.899 2.738 2.738 0 0 1-2.715 2.89 2.24 2.24 0 0 1-1.83-.876v3.039h-.981v-7.838Zm4.528 2.767a1.876 1.876 0 0 0-.483-1.38 1.879 1.879 0 0 0-1.33-.607 1.998 1.998 0 0 0-1.29 3.332c.335.367.795.597 1.29.643a1.868 1.868 0 0 0 1.712-1.248c.083-.237.117-.489.101-.74ZM112.369 35.62a2.728 2.728 0 0 1 .733-2.029 2.74 2.74 0 0 1 1.973-.87 2.274 2.274 0 0 1 1.856.876l.123-.78h.875v5.526h-.875l-.123-.78a2.212 2.212 0 0 1-1.856.876 2.743 2.743 0 0 1-2.706-2.82Zm4.676 0a1.828 1.828 0 0 0-1.813-1.988 1.994 1.994 0 0 0-1.809 1.988 1.995 1.995 0 0 0 1.809 1.987 1.837 1.837 0 0 0 1.804-1.987h.009ZM119.374 32.852h.876l.114.789a1.55 1.55 0 0 1 1.436-.876c.305-.006.606.067.876.21l-.228 1.007a1.752 1.752 0 0 0-.797-.201c-.805 0-1.261.621-1.261 1.655v2.986h-1.016v-5.57ZM123.753 33.763H123v-.876h.753v-1.506l.989-.236v1.751h1.261v.876h-1.261v4.615h-.989v-4.624ZM126.695 32.852h.876l.122.876a1.878 1.878 0 0 1 1.752-1.016c1.418 0 2.093.876 2.093 2.365v3.292h-.99v-3.082c0-1.077-.455-1.655-1.296-1.655s-1.524.718-1.524 2.285v2.461h-.998l-.035-5.526ZM135.198 38.51a2.63 2.63 0 0 1-2.562-1.783 2.64 2.64 0 0 1-.126-1.099 2.714 2.714 0 0 1 2.714-2.907 2.57 2.57 0 0 1 2.491 1.715c.12.34.166.702.137 1.06.009.132.009.264 0 .395h-4.379a1.763 1.763 0 0 0 1.142 1.644c.223.083.46.12.697.107a1.649 1.649 0 0 0 1.559-.972l.823.35a2.543 2.543 0 0 1-2.496 1.49Zm-1.751-3.38h3.354a1.546 1.546 0 0 0-.495-1.097 1.53 1.53 0 0 0-1.134-.401 1.647 1.647 0 0 0-1.708 1.498h-.017ZM138.859 32.852h.875l.114.788a1.561 1.561 0 0 1 1.436-.875c.305-.003.606.07.876.21l-.237 1.007a1.748 1.748 0 0 0-.796-.201c-.806 0-1.261.621-1.261 1.655v2.986h-.99l-.017-5.57ZM140.636 41.023a5.603 5.603 0 0 1-2.487.359 211.532 211.532 0 0 0-27.891.534c-.578.052-1.392.236-1.62-.193-.227-.429.675-.525 1.314-.63 2.005-.316 4.116-.184 6.182-.307 7.75-.473 15.518-.271 23.285 0 .42-.03.84.05 1.217.236Z",
    fill: "gray"
  })));
};
/* harmony default export */ var medrecruit_full = (SvgMedrecruitFull);
;// CONCATENATED MODULE: ./components/Logo/assets/medrecruit-short.svg
var medrecruit_short_path, medrecruit_short_path2;
function medrecruit_short_extends() { return medrecruit_short_extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, medrecruit_short_extends.apply(null, arguments); }

var SvgMedrecruitShort = function SvgMedrecruitShort(props) {
  return /*#__PURE__*/react.createElement("svg", medrecruit_short_extends({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), medrecruit_short_path || (medrecruit_short_path = /*#__PURE__*/react.createElement("path", {
    d: "m18.71 10.607 2.4-6.097a2.62 2.62 0 0 0-.035-1.98 2.6 2.6 0 0 0-1.407-1.385l-.117-.041a2.303 2.303 0 0 0-.353-.1h-.224a2.684 2.684 0 0 0-.27 0h-.465c-.12.026-.238.06-.353.1l-.123.041a2.6 2.6 0 0 0-1.4 1.388 2.62 2.62 0 0 0-.03 1.977l2.377 6.097ZM8.946 10.607 11.34 4.51a2.609 2.609 0 0 0-.027-1.98 2.589 2.589 0 0 0-1.408-1.385l-.118-.041a2.303 2.303 0 0 0-.353-.1H9.24a2.685 2.685 0 0 0-.27 0h-.465a2.93 2.93 0 0 0-.353.1l-.123.041a2.595 2.595 0 0 0-1.403 1.388A2.615 2.615 0 0 0 6.6 4.51l2.347 6.097ZM18.71 17.396l-2.4 6.097c-.25.639-.238 1.35.032 1.98.27.631.776 1.129 1.409 1.385l.112.041c.116.044.236.078.358.101H19.151c.12-.027.237-.06.353-.1l.123-.042a2.6 2.6 0 0 0 1.404-1.387c.268-.63.28-1.34.031-1.978l-2.352-6.097ZM8.946 17.396l-2.4 6.097a2.61 2.61 0 0 0 .03 1.982c.27.63.777 1.128 1.411 1.383l.112.041c.117.044.237.078.359.101h.929c.12-.027.237-.06.353-.1l.124-.042a2.595 2.595 0 0 0 1.402-1.387c.267-.63.277-1.34.027-1.978l-2.347-6.097Z",
    fill: "#278BE0"
  })), medrecruit_short_path2 || (medrecruit_short_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M24.387 16.802a2.66 2.66 0 0 0 2.189-3.053 2.648 2.648 0 0 0-3.037-2.2 2.66 2.66 0 0 0-2.188 3.052 2.649 2.649 0 0 0 3.036 2.2ZM13.804 16.84a2.654 2.654 0 0 0 2.647-2.66 2.654 2.654 0 0 0-2.647-2.662 2.654 2.654 0 0 0-2.646 2.661 2.654 2.654 0 0 0 2.646 2.661ZM3.647 11.518c-.524 0-1.035.156-1.47.448a2.674 2.674 0 0 0-.401 4.094 2.642 2.642 0 0 0 2.884.578 2.65 2.65 0 0 0 1.187-.98 2.671 2.671 0 0 0-.33-3.359 2.645 2.645 0 0 0-1.87-.781Z",
    fill: "#55ADEE"
  })));
};
/* harmony default export */ var medrecruit_short = (SvgMedrecruitShort);
;// CONCATENATED MODULE: ./components/Logo/Logo.tsx







var altText = "Medrecruit. A Medworld partner.";
var Logo = function(param) {
    var className = param.className, onClick = param.onClick, _type = param.type, type = _type === void 0 ? "medrecruit-full" : _type;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        prefetch: false,
        href: "/",
        passHref: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
            onClick: onClick,
            className: classnames_default()((Logo_module_default()).container, className),
            children: [
                type === "medrecruit-full" && /*#__PURE__*/ (0,jsx_runtime.jsx)(medrecruit_full, {
                    width: "100%",
                    height: "100%",
                    viewBox: "0 0 182 42",
                    "aria-label": altText
                }),
                type === "medrecruit-short" && /*#__PURE__*/ (0,jsx_runtime.jsx)(medrecruit_short, {
                    width: "100%",
                    height: "100%",
                    viewBox: "0 0 28 28",
                    "aria-label": altText
                })
            ]
        })
    });
};
/* harmony default export */ var Logo_Logo = (Logo);


/***/ }),

/***/ 82898:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "c": function() { return /* reexport */ ProfileBanner; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./modules/LandingHeaderV2/hooks/useUserDisplayInfo.ts
var useUserDisplayInfo = __webpack_require__(43707);
// EXTERNAL MODULE: ./utils/appClientConfig.ts
var appClientConfig = __webpack_require__(77469);
// EXTERNAL MODULE: ./utils/useAnalytics.ts + 2 modules
var useAnalytics = __webpack_require__(9800);
;// CONCATENATED MODULE: ./assets/profileBannerDoctor.png
/* harmony default export */ var profileBannerDoctor = ({"src":"https://cdn.medrecruit.medworld.com/8ab9b7fc0ee58df5cc13af32458786e3385f32a8/_next/static/media/profileBannerDoctor.45cf171f.png","height":404,"width":410,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAY1BMVEVMaXESNl+ARiqlbVoEP6N/kLuXteoqVI1jRzqEd4WKXVMGTb89W5hNVHoDWNyqoKpsiL69qafZuKombd2DrvXBtsJxc4uLa2KHcnoXVbi3dE6VVjNja4sDUs6Mi6XE1Pdjl+twEBImAAAAFnRSTlMAGrrsaPz+DGW+08L4/P3++/z+/fBEyeUPCgAAAAlwSFlzAAAWJQAAFiUBSVIk8AAAAEFJREFUCJljYAABFhZ2MM0kLskNotmZpXhkQTQjlzQvHwMDA4cYq4S4MAMDA6cEGxu/AoghxiokLwKSkhGQExQFAESVAoQENAWMAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":8});
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(29260);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-cookie-consent/build/index.js
var build = __webpack_require__(92491);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/useMediaQuery/useMediaQuery.js
var useMediaQuery = __webpack_require__(63457);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Button/Button.js
var Button = __webpack_require__(282);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/IconButton/IconButton.js
var IconButton = __webpack_require__(17812);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/Close.js
var Close = __webpack_require__(80366);
// EXTERNAL MODULE: ./components/ProfileBanner/ProfileBanner.module.scss
var ProfileBanner_module = __webpack_require__(38948);
var ProfileBanner_module_default = /*#__PURE__*/__webpack_require__.n(ProfileBanner_module);
;// CONCATENATED MODULE: ./components/ProfileBanner/ProfileBanner.tsx














var ProfileBanner = function(param) {
    var cookieConsentOverwrite = param.cookieConsentOverwrite;
    var ref = (0,react.useState)(false), closed = ref[0], setClosed = ref[1];
    var isDesktop = (0,useMediaQuery/* default */.Z)("(min-width: 768px)");
    var track = (0,useAnalytics/* useAnalytics */.z)();
    var isUserLoggedIn = (0,useUserDisplayInfo/* useUserDisplayInfo */.l)().isUserLoggedIn;
    var _practitionerProfileUrl;
    var profileUrl = (_practitionerProfileUrl = appClientConfig/* appClientConfig.practitionerProfileUrl */.p.practitionerProfileUrl) !== null && _practitionerProfileUrl !== void 0 ? _practitionerProfileUrl : "";
    var consent = cookieConsentOverwrite !== null && cookieConsentOverwrite !== void 0 ? cookieConsentOverwrite : (0,build.getCookieConsentValue)();
    if (consent !== "true" || isUserLoggedIn) {
        return null;
    }
    var VariablePill = function() {
        return isDesktop ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: "Top rates,"
                }),
                " negotiated for you"
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: "Competitive rates"
        });
    };
    var onBannerClose = function() {
        setClosed(true);
        track("Click", {
            action: "Close profile banner",
            "element text": "",
            "element type": "button"
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()((ProfileBanner_module_default()).bannerContainer, closed && (ProfileBanner_module_default()).closed),
        role: "banner",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (ProfileBanner_module_default()).imageContainer,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: profileBannerDoctor,
                    priority: true,
                    alt: "",
                    "aria-hidden": true,
                    width: 200,
                    height: 200
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                        className: (ProfileBanner_module_default()).header,
                        children: "Finding your next job just got easier."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: (ProfileBanner_module_default()).subHeader,
                        children: "Register to access"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                        className: (ProfileBanner_module_default()).benefitsPillsList,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: "Exclusive"
                                    }),
                                    " roles"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(VariablePill, {})
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: "Jobs"
                                    }),
                                    " matched to you"
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                className: (ProfileBanner_module_default()).getStartedButton,
                variant: "contained",
                href: "".concat(profileUrl, "/sign-up"),
                onClick: function() {
                    return track("Click", {
                        action: "Profile banner - get started",
                        "element text": "Get started",
                        "element type": "button"
                    });
                },
                children: "Get started"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                "aria-label": "close",
                className: (ProfileBanner_module_default()).closeButton,
                onClick: onBannerClose,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Close/* default */.Z, {})
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/ProfileBanner/index.ts



/***/ }),

/***/ 83361:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "A": function() { return /* binding */ Layout; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./components/ProfileBanner/index.ts + 2 modules
var ProfileBanner = __webpack_require__(82898);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Container/Container.js
var Container = __webpack_require__(43832);
// EXTERNAL MODULE: ./components/Logo/Logo.tsx + 2 modules
var Logo = __webpack_require__(30377);
;// CONCATENATED MODULE: ./components/Logo/index.ts


// EXTERNAL MODULE: ./modules/Context/useAuth0User.tsx
var useAuth0User = __webpack_require__(65200);
// EXTERNAL MODULE: ./utils/urlHelper.ts
var urlHelper = __webpack_require__(52484);
// EXTERNAL MODULE: ./utils/useAnalytics.ts + 2 modules
var useAnalytics = __webpack_require__(9800);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Button/Button.js
var Button = __webpack_require__(282);
// EXTERNAL MODULE: ./modules/LandingHeader/components/ActionButtons/ActionButtons.module.scss
var ActionButtons_module = __webpack_require__(81124);
var ActionButtons_module_default = /*#__PURE__*/__webpack_require__.n(ActionButtons_module);
;// CONCATENATED MODULE: ./modules/LandingHeader/components/ActionButtons/ActionButtons.tsx







var ActionButtons = function(param) {
    var onRegisterClick = param.onRegisterClick, onSignInClick = param.onSignInClick, redirectUrl = param.redirectUrl, preAction = param.preAction;
    var track = (0,useAnalytics/* useAnalytics */.z)();
    var signInUrl = (0,urlHelper/* getSignInUrlServerSide */.OV)(redirectUrl, preAction);
    var registerUrl = (0,urlHelper/* getRegisterUrlServerSide */.cl)({
        redirect_url: redirectUrl,
        action: preAction
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (ActionButtons_module_default()).actions,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                prefetch: false,
                href: signInUrl,
                as: signInUrl,
                passHref: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                    color: "primary",
                    "data-testid": "sign-in-button",
                    className: (ActionButtons_module_default()).signInButton,
                    onClick: function() {
                        track("Click nav Sign In", {});
                        onSignInClick === null || onSignInClick === void 0 ? void 0 : onSignInClick();
                    },
                    children: "SIGN IN"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                prefetch: false,
                href: registerUrl,
                as: registerUrl,
                passHref: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                    variant: "contained",
                    color: "primary",
                    "data-testid": "register-button",
                    className: (ActionButtons_module_default()).registerButton,
                    onClick: function() {
                        track("Click nav Register", {});
                        onRegisterClick === null || onRegisterClick === void 0 ? void 0 : onRegisterClick();
                    },
                    children: "REGISTER"
                })
            })
        ]
    });
};
/* harmony default export */ var ActionButtons_ActionButtons = (ActionButtons);

// EXTERNAL MODULE: ./modules/Context/NavigationContextProvider.tsx
var NavigationContextProvider = __webpack_require__(63365);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/useMediaQuery/useMediaQuery.js
var useMediaQuery = __webpack_require__(63457);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Collapse/Collapse.js
var Collapse = __webpack_require__(66037);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/AccountCircleOutlined.js
var AccountCircleOutlined = __webpack_require__(60737);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/ExpandLess.js
var ExpandLess = __webpack_require__(35025);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/ExpandMore.js
var ExpandMore = __webpack_require__(64566);
// EXTERNAL MODULE: ./modules/LandingHeader/components/NavigationItem/NavigationItem.module.scss
var NavigationItem_module = __webpack_require__(30987);
var NavigationItem_module_default = /*#__PURE__*/__webpack_require__.n(NavigationItem_module);
;// CONCATENATED MODULE: ./modules/LandingHeader/components/NavigationItem/NavigationItem.tsx











var NavigationItem = function(param) {
    var onNavItemClick = param.onNavItemClick, label = param.label, to = param.to, trackEventName = param.trackEventName, subItems = param.subItems, id = param.id, _isAside = param.isAside, isAside = _isAside === void 0 ? false : _isAside, testid = param.testid;
    var track = (0,useAnalytics/* useAnalytics */.z)();
    var router = (0,next_router.useRouter)();
    var ref = (0,react.useState)(false), isOpen = ref[0], setIsOpen = ref[1];
    var isMobile = (0,useMediaQuery/* default */.Z)(function(theme) {
        return theme.breakpoints.down("sm");
    });
    var isAsideOnMobile = isAside && isMobile;
    var hasSubMenu = subItems && subItems.length > 0;
    var hasCurrentInSubMenu = (0,react.useMemo)(function() {
        var hasCurrent = false;
        if ((router === null || router === void 0 ? void 0 : router.asPath) && hasSubMenu) {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = subItems[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var item = _step.value;
                    if (!!item.to && item.to === (router === null || router === void 0 ? void 0 : router.asPath)) {
                        hasCurrent = true;
                        break;
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
        return hasCurrent;
    }, [
        router === null || router === void 0 ? void 0 : router.asPath,
        hasSubMenu,
        subItems
    ]);
    var isLink = !!to;
    var isCurrent = isLink && (router === null || router === void 0 ? void 0 : router.asPath) === to || hasCurrentInSubMenu;
    // keep aside item open on mobile
    (0,react.useEffect)(function() {
        if (isAsideOnMobile) {
            setIsOpen(isAsideOnMobile);
        }
    }, [
        isAsideOnMobile
    ]);
    // close dropdowns if breakpoint changes to desktop
    (0,react.useEffect)(function() {
        if (!isMobile) {
            setIsOpen(false);
        }
    }, [
        isMobile
    ]);
    // open dropdowns on mobile when subitems contain the current page
    (0,react.useEffect)(function() {
        if (isMobile && hasCurrentInSubMenu) {
            setIsOpen(true);
        }
    }, [
        isMobile,
        hasCurrentInSubMenu
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        onMouseEnter: function() {
            return !isMobile && hasSubMenu && setIsOpen(true);
        },
        onMouseLeave: function() {
            return !isMobile && hasSubMenu && setIsOpen(false);
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classnames_default()((NavigationItem_module_default()).container, isOpen && (NavigationItem_module_default()).open, isAside && (NavigationItem_module_default()).aside),
                children: [
                    isLink && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        prefetch: false,
                        href: to,
                        as: to,
                        passHref: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            className: classnames_default()((NavigationItem_module_default()).inner, (NavigationItem_module_default()).link, isCurrent && (NavigationItem_module_default()).current),
                            onClick: function() {
                                trackEventName && track(trackEventName, {});
                                onNavItemClick === null || onNavItemClick === void 0 ? void 0 : onNavItemClick();
                            },
                            "data-testid": testid,
                            "aria-current": isCurrent,
                            children: label
                        })
                    }),
                    !isLink && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (NavigationItem_module_default()).inner,
                        "data-testid": testid,
                        children: [
                            isAside && !isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)(AccountCircleOutlined/* default */.Z, {
                                className: (NavigationItem_module_default()).icon
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: label
                            })
                        ]
                    }),
                    hasSubMenu && !isAsideOnMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        className: (NavigationItem_module_default()).expandButton,
                        onClick: function() {
                            return setIsOpen(!isOpen);
                        },
                        "aria-label": isOpen ? "Close ".concat(label) : "Open ".concat(label),
                        "aria-controls": id,
                        "aria-haspopup": "true",
                        "data-testid": "top-nav-".concat(id, "-expand-button"),
                        children: isOpen ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ExpandLess/* default */.Z, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ExpandMore/* default */.Z, {})
                    })
                ]
            }),
            hasSubMenu && /*#__PURE__*/ (0,jsx_runtime.jsx)(Collapse/* default */.Z, {
                in: isOpen,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                    className: classnames_default()((NavigationItem_module_default()).submenu, isAside && (NavigationItem_module_default()).aside),
                    id: id,
                    children: subItems.map(function(item) {
                        var isCurrentSubItem = !!item.to && (router === null || router === void 0 ? void 0 : router.asPath) === item.to;
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: (NavigationItem_module_default()).submenuItem,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                prefetch: false,
                                href: item.to,
                                as: item.to,
                                passHref: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    className: classnames_default()((NavigationItem_module_default()).submenuLink, isCurrentSubItem && (NavigationItem_module_default()).current),
                                    onClick: function() {
                                        onNavItemClick === null || onNavItemClick === void 0 ? void 0 : onNavItemClick();
                                    },
                                    "data-testid": item.testid,
                                    "aria-current": isCurrentSubItem,
                                    children: item.label
                                })
                            })
                        }, item.label);
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var NavigationItem_NavigationItem = (NavigationItem);

// EXTERNAL MODULE: ./modules/LandingHeader/config.ts
var config = __webpack_require__(33145);
// EXTERNAL MODULE: ./modules/LandingHeader/components/Navigation/Navigation.module.scss
var Navigation_module = __webpack_require__(52892);
var Navigation_module_default = /*#__PURE__*/__webpack_require__.n(Navigation_module);
;// CONCATENATED MODULE: ./modules/LandingHeader/components/Navigation/Navigation.tsx







var Navigation = function(param) {
    var onNavItemClick = param.onNavItemClick, isUserLoggedIn = param.isUserLoggedIn, userName = param.userName, actionButtons = param.actionButtons;
    var navigationList = (0,react.useContext)(NavigationContextProvider/* NavigationContext */.kH);
    if (navigationList.length === 0) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
                "aria-label": "Top navigation",
                className: (Navigation_module_default()).nav,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                    className: (Navigation_module_default()).list,
                    children: navigationList.map(function(item) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: (Navigation_module_default()).listItem,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NavigationItem_NavigationItem, {
                                label: item.label,
                                trackEventName: item.trackEventName,
                                to: item.to,
                                onNavItemClick: onNavItemClick,
                                subItems: item.subItems,
                                id: item.id
                            })
                        }, item.label);
                    })
                })
            }),
            isUserLoggedIn && /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
                "aria-label": "User navigation",
                className: classnames_default()((Navigation_module_default()).nav, (Navigation_module_default()).aside),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                    className: (Navigation_module_default()).list,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        className: (Navigation_module_default()).listItem,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NavigationItem_NavigationItem, {
                            label: "Hi ".concat(userName),
                            to: "",
                            onNavItemClick: onNavItemClick,
                            subItems: config/* USER_PROFILE_SUB_NAVIGATION_LIST */.X,
                            id: "user_profile_pages",
                            isAside: true
                        })
                    })
                })
            }),
            actionButtons
        ]
    });
};
/* harmony default export */ var Navigation_Navigation = (Navigation);

// EXTERNAL MODULE: ./utils/useCloseOnOutsideClick.ts
var useCloseOnOutsideClick = __webpack_require__(42361);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Slide/Slide.js
var Slide = __webpack_require__(82285);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/Close.js
var Close = __webpack_require__(80366);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/Menu.js
var Menu = __webpack_require__(48884);
// EXTERNAL MODULE: ./modules/LandingHeader/components/LandingHeader/LandingHeader.module.scss
var LandingHeader_module = __webpack_require__(56298);
var LandingHeader_module_default = /*#__PURE__*/__webpack_require__.n(LandingHeader_module);
;// CONCATENATED MODULE: ./modules/LandingHeader/components/LandingHeader/LandingHeader.tsx













var mobileMenuId = "primary-menu-mobile";
var LandingHeader = function(param) {
    var onRegisterClick = param.onRegisterClick, redirectUrl = param.redirectUrl, preAction = param.preAction;
    var track = (0,useAnalytics/* useAnalytics */.z)();
    var user = (0,useAuth0User/* useAuth0User */.a)().user;
    var isUserLoggedIn = !!user;
    var ref;
    var userName = (ref = user === null || user === void 0 ? void 0 : user.given_name) !== null && ref !== void 0 ? ref : "";
    var isShortLogo = (0,useMediaQuery/* default */.Z)(function(theme) {
        return theme.breakpoints.between("md", 1200);
    }); // 1200 magic value is also used in CSS, make sure to update in both places
    var isSmallScreen = (0,useMediaQuery/* default */.Z)(function(theme) {
        return theme.breakpoints.down("sm");
    });
    var ref1 = (0,react.useState)(false), isOpen = ref1[0], setIsOpen = ref1[1];
    var containerRef = (0,useCloseOnOutsideClick/* useCloseOnOutsideClick */.N)(isOpen, setIsOpen);
    // close Mobile menu if breakpoint is changed to desktop
    (0,react.useEffect)(function() {
        if (!isSmallScreen) {
            setIsOpen(false);
        }
    }, [
        isSmallScreen
    ]);
    var panel = /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classnames_default()((LandingHeader_module_default()).panel, isSmallScreen && isOpen && (LandingHeader_module_default()).showPanel),
        id: mobileMenuId,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (LandingHeader_module_default()).panelInner,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Navigation_Navigation, {
                onNavItemClick: function() {
                    return setIsOpen(false);
                },
                isUserLoggedIn: isUserLoggedIn,
                userName: userName,
                actionButtons: !isUserLoggedIn ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ActionButtons_ActionButtons, {
                    preAction: preAction,
                    redirectUrl: redirectUrl,
                    onRegisterClick: function() {
                        onRegisterClick === null || onRegisterClick === void 0 ? void 0 : onRegisterClick();
                        setIsOpen(false);
                    },
                    onSignInClick: function() {
                        return setIsOpen(false);
                    }
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
            })
        })
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            isSmallScreen && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classnames_default()((LandingHeader_module_default()).backdrop, isOpen && (LandingHeader_module_default()).visible)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("header", {
                className: (LandingHeader_module_default()).container,
                ref: containerRef,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (LandingHeader_module_default()).headerInner,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Logo/* default */.Z, {
                                className: (LandingHeader_module_default()).logo,
                                type: isShortLogo ? "medrecruit-short" : "medrecruit-full",
                                onClick: function() {
                                    track("Click nav Logo", {});
                                    setIsOpen(false);
                                }
                            }),
                            isSmallScreen && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                className: (LandingHeader_module_default()).toggleButton,
                                onClick: function() {
                                    return setIsOpen(!isOpen);
                                },
                                "aria-label": isOpen ? "Close menu" : "Open menu",
                                "aria-controls": mobileMenuId,
                                "aria-haspopup": "true",
                                "data-testid": "top-nav-mobile-menu-expand-button",
                                children: isOpen ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Close/* default */.Z, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu/* default */.Z, {})
                            })
                        ]
                    }),
                    isSmallScreen && /*#__PURE__*/ (0,jsx_runtime.jsx)(Slide/* default */.Z, {
                        in: isOpen,
                        direction: "down",
                        children: panel
                    }),
                    !isSmallScreen && panel
                ]
            })
        ]
    });
};
/* harmony default export */ var LandingHeader_LandingHeader = (LandingHeader);

;// CONCATENATED MODULE: ./modules/LandingHeader/index.ts


// EXTERNAL MODULE: ./modules/Layout/style.module.scss
var style_module = __webpack_require__(89495);
var style_module_default = /*#__PURE__*/__webpack_require__.n(style_module);
;// CONCATENATED MODULE: ./modules/Layout/index.tsx







var CookieConsentPrompt = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 1273).then(__webpack_require__.bind(__webpack_require__, 26871));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(26871)
            ];
        }
    }
});
var Layout = function(param) {
    var redirectUrl = param.redirectUrl, preAction = param.preAction, onClickRegisterFn = param.onClickRegisterFn, children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                className: (style_module_default()).root,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
                    className: (style_module_default()).main,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(LandingHeader_LandingHeader, {
                            redirectUrl: redirectUrl,
                            preAction: preAction,
                            onRegisterClick: onClickRegisterFn
                        }),
                        children
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CookieConsentPrompt, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfileBanner/* ProfileBanner */.c, {})
        ]
    });
};


/***/ }),

/***/ 42361:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ useCloseOnOutsideClick; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

function useCloseOnOutsideClick(isOpen, onToggle) {
    var containerRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    // close if clicked outside
    var handleOutsideClick = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(e) {
        if (isOpen) {
            var ref;
            if ((ref = containerRef.current) === null || ref === void 0 ? void 0 : ref.contains(e.target)) {
                // inside click
                return;
            }
            // outside click
            onToggle(false);
        }
    }, [
        isOpen
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        document.addEventListener("mousedown", handleOutsideClick);
        return function() {
            return document.removeEventListener("mousedown", handleOutsideClick);
        };
    }, [
        handleOutsideClick
    ]);
    return containerRef;
}


/***/ }),

/***/ 27259:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"Logo_container__B0M6K"};

/***/ }),

/***/ 38948:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"bannerContainer":"ProfileBanner_bannerContainer__kQhdF","closed":"ProfileBanner_closed__qtWy_","imageContainer":"ProfileBanner_imageContainer__VFnDG","header":"ProfileBanner_header__oXcWU","subHeader":"ProfileBanner_subHeader__UqIrm","benefitsPillsList":"ProfileBanner_benefitsPillsList__YVD5X","closeButton":"ProfileBanner_closeButton__O17v8","getStartedButton":"ProfileBanner_getStartedButton__dMz_Q"};

/***/ }),

/***/ 81124:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"actions":"ActionButtons_actions__Ku3EY","signInButton":"ActionButtons_signInButton__qsu9u","registerButton":"ActionButtons_registerButton__NPvYw"};

/***/ }),

/***/ 56298:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"backdrop":"LandingHeader_backdrop__BZx5x","visible":"LandingHeader_visible__FNDnb","container":"LandingHeader_container__qRscO","headerInner":"LandingHeader_headerInner__uG1T2","logo":"LandingHeader_logo__9JcFN","toggleButton":"LandingHeader_toggleButton___awCs","panel":"LandingHeader_panel__BHfIv","showPanel":"LandingHeader_showPanel__e_9ht","panelInner":"LandingHeader_panelInner__hLTij"};

/***/ }),

/***/ 52892:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"nav":"Navigation_nav__zmDiD","aside":"Navigation_aside__G33Mp","list":"Navigation_list__mACqG","listItem":"Navigation_listItem__robKl"};

/***/ }),

/***/ 30987:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"NavigationItem_container__58_cF","inner":"NavigationItem_inner__E8E8t","link":"NavigationItem_link__Ek_33","current":"NavigationItem_current__eF2qk","icon":"NavigationItem_icon__cqSfq","expandButton":"NavigationItem_expandButton__w9GEg","open":"NavigationItem_open__P3Xe1","aside":"NavigationItem_aside__qC6__","submenu":"NavigationItem_submenu__EIJZ2","submenuItem":"NavigationItem_submenuItem__fSy1T","submenuLink":"NavigationItem_submenuLink___1Kha"};

/***/ }),

/***/ 89495:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"main":"style_main__aPM27","root":"style_root__W_Tp8"};

/***/ })

}]);